import request from '../utils/request';

export function postPersonOrderInfo (){
    return request({
        url: "/wxmanager/clentPayV3/jsapiWePay",
        method:'post',
    });
}
export function postJsSdk (){
    return request({
        url: "/wxmanager/clentPay/jsSdk",
        method:'post',
    });
}
export function getProductList (){
    return request({
        url: "/wxmanager/person/findProductList",
        method:'post',
    });
}
export function getUserOrderList (){
    return request({
        url: "/wxmanager/person/findUserOrderSuccessList",
        method:'post',
    });
}
export function getUserOrderHealthPlan (){
    return request({
        url: "/wxmanager/person/findHeartPlanOrderList",
        method:'post',
    });
}
export function getdUserGiftCards (){
    return request({
        url: "/wxmanager/person/findUserGiftCardsList",
        method:'post',
    });
}


  